






























import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { PiningPartsHelper } from '../../NewMultiMessageEditorWithMedia/types'
import { MediaEditorMode } from "../../types";
import { CustomMediaTypes } from '../types'
import MediaList from './components/MediaList/MediaList.vue'
import PinMediaActions from './components/MediaList/PinMediaActions.vue'
import UploadMediaModal from './components/UploadMediaModal/UploadMediaModal.vue'
import MediaManager from './logic/MediaManager'
import { FileType } from './types'

@Component({
  components: {
    MediaList,
    UploadMediaModal,
    PinMediaActions,
  }
})
export default class MessageMedia extends Vue {
  @Prop() mediaManager!: MediaManager

  @Prop() disabled!: boolean

  @Prop({ type: Array, default: () => [] }) blacklistMediaButtonTypes!:Array<FileType>
  @Prop({ type: String }) mediaButtonsMessage!:string

  @Prop() editorMode!: MediaEditorMode

  @Prop() targetToUpload!: Record<string, string | number>

  @Prop() customMediaTypes!: CustomMediaTypes

  @Prop({ type: Boolean, required: false, default: false }) draggable!: boolean

  /** Только для MultiMessageEditor */
  @Prop() pinMediaHelper?: PiningPartsHelper
  /**------------------------------*/

  @Watch('isOpen')
  isOpenWatcher(val: boolean): void {
    if (!val) {
      this.mediaManager.setFileType(null)
    }
  }

  isOpen = false

  get isUploadButtonsDisabled(): boolean {
    return !this.mediaManager.canUploadMoreFiles()
  }

  get albumSupportButtonDisabled(): boolean {
    const attachments = this.mediaManager.attachments.filter(a => a.type !== FileType.Custom)

    if (this.editorMode === MediaEditorMode.TelegramAll) {
      return false
    }

    return attachments.length > 0 && !attachments.some((uploadedFile) => [ FileType.Image, FileType.SpoilerImage, FileType.Video, FileType.SpoilerVideo ].includes(uploadedFile.type))
  }

  uploadFileTypes(): Array<FileType> {
    return Object.values(FileType)
      .filter((type) => type !== FileType.TopMessagePreview)
      .filter((type) => {
        if ([ FileType.Image, FileType.SpoilerImage, FileType.Video, FileType.SpoilerVideo ].includes(type) && !(this.albumSupportButtonDisabled || this.isUploadButtonsDisabled)) {
          return type
        }

        if (!(this.isUploadButtonsDisabled || this.nonAlbumButtonDisabled(type))) {
          return type
        }
      })
  }

  nonAlbumButtonDisabled(fileType: FileType): boolean {
    const attachments = this.mediaManager.attachments.filter(a => a.type !== FileType.Custom)

    if (this.editorMode === MediaEditorMode.TelegramAll) {
      return false
    }

    const singleFileTypes = [
      FileType.VideoNote,
      FileType.Voice,
      FileType.MessagePreview,
      FileType.TopMessagePreview,
      FileType.Animation,
    ]

    const singleFileTypeInMessage = attachments.some((uploadFile) => {
      return singleFileTypes.includes(uploadFile.type)
    })

    return attachments.length > 0 && (!attachments.every((uploadFile) => uploadFile.type === fileType) || singleFileTypeInMessage)
  }
}
